/**
 * @module-tag agents-ai-nitro
 * Known Asana panel clientActions (mirrors generated-apps/asana-mcp-app index.js).
 * Embedded on mountedPanels so the orchestrator can expose tools even when the
 * marketplace catalog has not yet returned execution:frontend entries.
 */ export const ASANA_PANEL_RESOURCE_URI = 'ui://widget/asana-panel.html';
export const ASANA_PANEL_CLIENT_ACTIONS = [
    {
        name: 'asana_panel_set_view',
        description: 'Switch the Asana panel chrome view (List, Board, Calendar, Dashboard, or Files). Does not change Asana data.',
        resourceUri: ASANA_PANEL_RESOURCE_URI,
        inputSchema: {
            type: 'object',
            properties: {
                view: {
                    type: 'string',
                    enum: [
                        'List',
                        'Board',
                        'Calendar',
                        'Dashboard',
                        'Files'
                    ]
                }
            },
            required: [
                'view'
            ],
            additionalProperties: false
        }
    },
    {
        name: 'asana_panel_prefill_create',
        description: 'Prefill the Asana panel create-task form (name and optional sectionName). Does not create the task until the user submits.',
        resourceUri: ASANA_PANEL_RESOURCE_URI,
        inputSchema: {
            type: 'object',
            properties: {
                name: {
                    type: 'string'
                },
                sectionName: {
                    type: 'string'
                }
            },
            required: [
                'name'
            ],
            additionalProperties: false
        }
    },
    {
        name: 'asana_panel_focus_task',
        description: 'Highlight and scroll to a task already loaded in the Asana panel snapshot. Pass taskGid and/or name.',
        resourceUri: ASANA_PANEL_RESOURCE_URI,
        inputSchema: {
            type: 'object',
            properties: {
                taskGid: {
                    type: 'string'
                },
                name: {
                    type: 'string'
                }
            },
            additionalProperties: false
        }
    },
    {
        name: 'asana_panel_get_ui_state',
        description: 'Read-only snapshot of the Asana panel UI: current view, draft inputs, task counts per section.',
        resourceUri: ASANA_PANEL_RESOURCE_URI,
        inputSchema: {
            type: 'object',
            properties: {},
            additionalProperties: false
        }
    }
];
export const clientActionsForResourceUri = (resourceUri)=>{
    if (resourceUri === ASANA_PANEL_RESOURCE_URI) {
        return ASANA_PANEL_CLIENT_ACTIONS.map((a)=>({
                name: a.name,
                description: a.description,
                resourceUri: a.resourceUri,
                inputSchema: a.inputSchema
            }));
    }
    return [];
};
